import {
  useEffect, useMemo, useRef, useState,
} from 'react'
import { MagnifyingGlass } from '@Infowijs-eng/component-library/icons'
import useMagisterLocations from '../../hooks/data/useMagisterLocations'
import TextInputWithAutoComplete from '../TextInputWithAutoComplete'
import { MagisterOrganisation } from '../../types'

interface MagisterSetupProps {
  customerProductName: string
  currentOrganisationId: string
  onSelectedOrganisation: (id: string | undefined) => void
}

export default function ExporterMagisterSetup({
  customerProductName,
  currentOrganisationId,
  onSelectedOrganisation,
}: MagisterSetupProps): JSX.Element {
  const [selectedOrganisation, setSelectedOrganisation] = useState<MagisterOrganisation | undefined>(undefined)
  const [searchValue, setSearchValue] = useState('')
  const touched = useRef(false)

  const { data: locations } = useMagisterLocations(customerProductName)

  useEffect(() => {
    if (touched.current) return

    const existingLocation = locations?.find(({ id }) => id === currentOrganisationId)
    if (existingLocation) {
      setSelectedOrganisation(existingLocation)
      onSelectedOrganisation(existingLocation.id)
    }
  }, [currentOrganisationId, locations, onSelectedOrganisation])

  const filteredInstitutes = useMemo(
    () => locations?.map((location) => ({
      ...location,
      label: location.name,
      key: location.id,
    })).filter((location) => location.name.toLowerCase().includes(searchValue.toLowerCase())),
    [locations, searchValue],
  )

  return (
    <div>
      <div className="font-bold pb-2">Choose a school</div>
      <TextInputWithAutoComplete
        name="search institute"
        placeholder="Search for school name"
        value={selectedOrganisation ? selectedOrganisation.name : undefined}
        disabled={!!selectedOrganisation}
        onChange={(e) => !selectedOrganisation && setSearchValue(e.target.value)}
        autoCompleteResults={(filteredInstitutes && filteredInstitutes.length > 0) ? filteredInstitutes : null}
        onAutoCompleteSelect={(id) => {
          const selected = filteredInstitutes.find((item) => item.id === id)
          if (selected) {
            touched.current = true
            setSelectedOrganisation(selected)
            onSelectedOrganisation(selected.id)
          }
        }}
        onReset={() => {
          touched.current = true
          setSelectedOrganisation(undefined)
          onSelectedOrganisation(undefined)
        }}
        trailingAddon={<MagnifyingGlass className="text-[1.25rem] px-1" />}
      />
    </div>
  )
}
